export default class RewardHistory {
  constructor(state = {}) {
    this.params = {
      id: state.id,
      value: state.value,
      type: state.type,
      createdAt: state.createdAt,
      updatedAt: state.updatedAt,
      expiredAt: state.expiredAt
    };
  }

  get object() {
    return this.params;
  }

  fromFirestore() {
    return {
      ...this.params,
      createdAt: this.params.createdAt && this.params.createdAt.toDate(),
      updatedAt: this.params.updatedAt && this.params.updatedAt.toDate(),
      expiredAt: this.params.expiredAt && this.params.expiredAt.toDate()
    };
  }

  static getRewardHistoryTypeLabel(type) {
    switch (type) {
      case 'earn':
        return '撮影報酬';
      case 'payment':
        return '出金';
      default:
        return '';
    }
  }
}
